<script>

    import { push } from 'svelte-spa-router'

</script>

<section class="hero is-primary is-fullheight">
    <div class="hero-body">
        <div class="container has-text-centered">
            <p class="title">Rastreo de paquetes</p>
            <button type="button" class="button is-light" on:click={() => push('#/')}>
                Volver al inicio de sesión
            </button>
        </div>
    </div>
</section>
